<template>
  <div>
    <div class="personal-data__container">
      <router-link class="gui-btn gui-btn--red gui-btn--w-207 u-margin-b-24"
                   :to="{name: 'news-list', query: $route.query}">
        {{$t('form.news.back-to-news-list')}}
      </router-link>
    </div>
    <section class="personal-data__container" v-if="item">
      <div class="news__editor" v-if="editor">
        <div class="a-container-form"
             :class="{'a-input-group--error': $v.editor.title.$error}">
          <div class="a-label">{{$t('form.news.title')}}: </div>
          <div class="a-form-field a-width-100-percent">
            <input type="text"
                   class="a-input a-input--w-max"
                   v-model="editor.title">
            <span class="a-validation-error" v-if="$v.editor.title.$dirty && !$v.editor.title.required">{{$t('labels.mandatory-field')}}</span>
          </div>
        </div>
        <div class="a-container-form a-container-form--align-start"
             :class="{'a-input-group--error': $v.editor.briefDescription.$error}">
          <div class="a-label">{{$t('form.news.brief-description')}}: </div>
          <div class="a-form-field a-width-100-percent">
            <textarea class="a-textarea " rows="2" v-model="editor.briefDescription"></textarea>
            <span class="a-validation-error" v-if="$v.editor.briefDescription.$dirty && !$v.editor.briefDescription.required">{{$t('labels.mandatory-field')}}</span>
          </div>
        </div>

        <div class="a-container-form">
          <div class="a-label">
            Показать на главной
          </div>
          <div class="a-input-group a-width-auto"
               :class="{'a-input-group--error': $v.editor.from.$anyError}">
            <p class="u-margin-right-7">c</p>
            <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
            <date-picker time="startOfDay" v-model="editor.from"></date-picker>
          </div>
          <div class="a-input-group a-width-auto"
               :class="{'a-input-group--error': $v.editor.to.$anyError}">
            <p class="u-margin-right-7">до</p>
            <div class="a-input-group__prepend "><img src="@/assets/img/static/vector.svg" alt=""></div>
            <date-picker time="endOfDay" v-model="editor.to"></date-picker>
          </div>
        </div>

        <div class="a-container-form a-container-form--align-start"
             :class="{'a-input-group--error': $v.editor.content.$error}">
          <div class="a-label">{{$t('form.news.body')}}: </div>
          <div class="a-form-field a-width-100-percent">
            <textarea class="a-textarea " rows="20" v-model="editor.content"></textarea>
            <span class="a-validation-error" v-if="$v.editor.content.$dirty && !$v.editor.content.required">{{$t('labels.mandatory-field')}}</span>
          </div>
        </div>
        <div class="news__footer">
          <div class="a-flex-start a-width-100-percent">
            <button class="gui-btn gui-btn--red gui-btn--w-140 u-margin-right-20 u-margin-b-13" @click.prevent="onSaveClick">{{$t('buttons.save')}}</button>
            <button class="gui-btn gui-btn--white-border gui-btn--w-140 u-margin-b-13" @click.prevent="onCancelClick">{{$t('buttons.cancel')}}</button>
          </div>
        </div>
      </div>

      <div class="news__cart news__cart--single a-width-100-percent" v-else>
        <div class="news__header">
          <div class="news__title" v-html="escape(item.title)"></div>
          <date-time class="news__time-date" :value="item.publicationDate"></date-time>
        </div>
        <div class="news__body" v-if="item.from || item.to">
          <div class="news__text" >
            Отображать на главной
              с <date-time tag="span" :value="item.from" :tz="false"></date-time>
              по <date-time tag="span" :value="item.to" :tz="false"></date-time>
          </div>
        </div>
        <div class="news__body">
          <div class="news__text">
            <p v-html="escape(item.briefDescription)"></p>
            <p v-html="escape(item.content)"></p>
          </div>
        </div>
        <div class="news__footer" v-if="canEdit ">
          <div class="a-flex-start a-width-100-percent">
            <button class="gui-btn gui-btn--red gui-btn--w-150 u-margin-right-20" @click.prevent="onEditClick">{{$t('buttons.modify')}}</button>
            <button class="gui-btn gui-btn--red" @click.prevent="onArchiveClick">{{$t('form.news.to-archive')}}</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import _ from 'lodash'
  import { required, requiredIf } from '@/validators'

  export default {
    data: () => ({
      editor: undefined
    }),

    computed: {
      newsId() {
        return +this.$route.params.id;
      },

      item() {
        return this.$store.getters.newsItem(this.newsId);
      },

      canEdit() {
        const user = this.$store.getters.currentUser;
        return user && user.permissions.CAN_EDIT_NEWS;
      }
    },

    validations: {
      editor: {
        title: {
          required
        },
        briefDescription: {
          required: () => true
        },
        content: {
          required: () => true
        },
        from: {
          required: requiredIf(function() {
            return this.editor.to;
          }),
          validState: function(value, item) {
            return !value || (item.to && value <= item.to)
          }
        },

        to: {
          required: requiredIf(function() {
            return this.editor.from;
          }),
          validState: function(value, item) {
            return !value || (item.from && value >= item.from)
          }
        }
      }
    },

    mounted() {
      this.runBlockerAction(async () => {
        try {
          await this.$store.dispatch('fetchNewsItem', { id: this.newsId });
        }
        catch(e) {
          console.error('unable to retrieve news', e);
        }
      });
    },

    methods: {
      async onArchiveClick() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('archiveNewsItem', { id: this.item.id });
            this.$router.push({ name: 'news-list' });
          }
          catch(e) {
            console.log('unable to archive news item', e);

            this.showError({
              title: 'Ошибка',
              label: 'Что-то пошло не так'
            })
          }
        });
      },

      onEditClick() {
        this.editor = {
          ...this.item
        };
      },

      onCancelClick() {
        this.editor = undefined;
      },

      async onSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) {
          return
        }

        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('updateNews', this.editor);
            this.editor = undefined;
          }
          catch (e) {
            console.error('unable to update news', e);

            this.showError({
              title: 'Ошибка',
              error: 'Что-то пошло не так'
            })
          }
        });
      }
    }
  }
</script>

<style scoped>

</style>
